import { render } from "./my-remote-grid.vue?vue&type=template&id=09225dc5"
import script from "./my-remote-grid.vue?vue&type=script&lang=js"
export * from "./my-remote-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__